import type { Skill } from '@/lib/api/types/skills';
import { tempoApi } from '../tempoApi';

const getSkills = async (): Promise<Skill[]> => {
  const response = await tempoApi().get('api/v1/capacity/skills').json<{ items: Skill[] }>();
  return response.items;
};

const createSkillsBulk = async (skills: Array<{ name: string }>): Promise<Skill[]> => {
  return await tempoApi()
    .post('api/v1/capacity/skills/bulk', {
      json: {
        skills,
      },
    })
    .json<Skill[]>();
};

const updateSkill = async (id: number, name: string): Promise<Skill> => {
  return await tempoApi()
    .put(`api/v1/capacity/skills/${id}`, {
      json: {
        name,
      },
    })
    .json<Skill>();
};

const deleteSkill = async (id: number): Promise<void> => {
  await tempoApi().delete(`api/v1/capacity/skills/${id}`);
};

export const SkillsApi = {
  getSkills,
  createSkillsBulk,
  updateSkill,
  deleteSkill,
};
